module.exports = __webpack_public_path__ + "img/16.9553c58f.jpg";